module.exports = __webpack_public_path__ + "static/media/kids_35.a243ca04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_35.jpg
// module id = 5891
// module chunks = 0